import { languageLabel, LanguageEnum, PlatformContentEnum } from "../../config";

export enum ReginEnum {
  NORTH_AMERICA = "North America",
  LATIN_AMERICA = "Latin America",
  WESTERN_EUROPE = "Western Europe",
  EASTERN_EUROPE = "Eastern Europe",
  EASTERN_EUROPE_AND_RUSSIA = "Eastern Europe & Russia",
  MIDDLE_EAST = "Middle East",
  SOUTH_ASIA = "South Asia",
  SOUTH_EAST_ASIA = "Southeast Asia",
  EAST_ASIA = "East Asia",
  OCEANIA = "Oceania",
  AFRICA = "Africa",
  Other = "Other",
}

// 英语国家语言包
export const enLocationsBag = [
  [ReginEnum.NORTH_AMERICA, "US"],
  [ReginEnum.NORTH_AMERICA, "CA"],
  [ReginEnum.WESTERN_EUROPE, "GB"],
  [ReginEnum.WESTERN_EUROPE, "IE"],
  [ReginEnum.OCEANIA, "AU"],
  [ReginEnum.OCEANIA, "NZ"],
  [ReginEnum.SOUTH_EAST_ASIA, "SG"],
  [ReginEnum.EAST_ASIA, "HK"],
];

// 发达国家语言包
export const developedCountriesBag = [
  [ReginEnum.NORTH_AMERICA, "US"],
  [ReginEnum.EAST_ASIA, "JP"],
  [ReginEnum.WESTERN_EUROPE, "DE"],
  [ReginEnum.WESTERN_EUROPE, "GB"],
  [ReginEnum.WESTERN_EUROPE, "FR"],
  [ReginEnum.NORTH_AMERICA, "CA"],
  [ReginEnum.EAST_ASIA, "KR"],
  [ReginEnum.WESTERN_EUROPE, "IT"],
  [ReginEnum.OCEANIA, "AU"],
  [ReginEnum.WESTERN_EUROPE, "ES"],
  [ReginEnum.WESTERN_EUROPE, "NL"],
  [ReginEnum.WESTERN_EUROPE, "CH"],
  [ReginEnum.EAST_ASIA, "TW"],
  [ReginEnum.WESTERN_EUROPE, "SE"],
  [ReginEnum.WESTERN_EUROPE, "BE"],
  [ReginEnum.WESTERN_EUROPE, "AT"],
  [ReginEnum.WESTERN_EUROPE, "NO"],
  [ReginEnum.WESTERN_EUROPE, "IE"],
  [ReginEnum.SOUTH_EAST_ASIA, "SG"],
  [ReginEnum.EAST_ASIA, "HK"],
  [ReginEnum.WESTERN_EUROPE, "DK"],
  [ReginEnum.WESTERN_EUROPE, "FI"],
  [ReginEnum.OCEANIA, "NZ"],
  [ReginEnum.WESTERN_EUROPE, "GR"],
  [ReginEnum.WESTERN_EUROPE, "PT"],
  [ReginEnum.WESTERN_EUROPE, "AD"],
  [ReginEnum.WESTERN_EUROPE, "PT-30"],
  [ReginEnum.WESTERN_EUROPE, "ES-CN"],
  [ReginEnum.WESTERN_EUROPE, "HR"],
  [ReginEnum.MIDDLE_EAST, "CY"],
  [ReginEnum.WESTERN_EUROPE, "GI"],
  [ReginEnum.WESTERN_EUROPE, "IS"],
  [ReginEnum.WESTERN_EUROPE, "JE"],
  [ReginEnum.WESTERN_EUROPE, "LI"],
  [ReginEnum.WESTERN_EUROPE, "LU"],
  [ReginEnum.EAST_ASIA, "MO"],
  [ReginEnum.WESTERN_EUROPE, "MT"],
  [ReginEnum.WESTERN_EUROPE, "MC"],
  [ReginEnum.WESTERN_EUROPE, "SM"],
  [ReginEnum.WESTERN_EUROPE, "SI"],
  [ReginEnum.WESTERN_EUROPE, "VA"],
];

// 发达国家 + 高收入国家语言包
export const developedCountriesAndHighIncomeCountriesBag = [
  ...developedCountriesBag,
  [ReginEnum.LATIN_AMERICA, "BR"],
  [ReginEnum.LATIN_AMERICA, "MX"],
  [ReginEnum.SOUTH_EAST_ASIA, "ID"],
  [ReginEnum.MIDDLE_EAST, "SA"],
  [ReginEnum.MIDDLE_EAST, "TR"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "PL"],
  [ReginEnum.LATIN_AMERICA, "AR"],
  [ReginEnum.SOUTH_EAST_ASIA, "TH"],
  [ReginEnum.MIDDLE_EAST, "AE"],
  [ReginEnum.SOUTH_EAST_ASIA, "MY"],
  [ReginEnum.SOUTH_EAST_ASIA, "PH"],
  [ReginEnum.LATIN_AMERICA, "CO"],
  [ReginEnum.SOUTH_EAST_ASIA, "VN"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "CZ"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "RO"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "HU"],
  [ReginEnum.MIDDLE_EAST, "IL"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "AL"],
  [ReginEnum.OCEANIA, "AS"],
  [ReginEnum.NORTH_AMERICA, "AI"],
  [ReginEnum.LATIN_AMERICA, "AG"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "AM"],
  [ReginEnum.LATIN_AMERICA, "AW"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "AZ"],
  [ReginEnum.LATIN_AMERICA, "BS"],
  [ReginEnum.MIDDLE_EAST, "BH"],
  [ReginEnum.LATIN_AMERICA, "BB"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "BY"],
  [ReginEnum.LATIN_AMERICA, "BZ"],
  [ReginEnum.NORTH_AMERICA, "BM"],
  [ReginEnum.LATIN_AMERICA, "BO"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "BA"],
  [ReginEnum.Other, "VG"],
  [ReginEnum.SOUTH_EAST_ASIA, "BN"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "BG"],
  [ReginEnum.SOUTH_EAST_ASIA, "KH"],
  [ReginEnum.NORTH_AMERICA, "KY"],
  [ReginEnum.LATIN_AMERICA, "CL"],
  [ReginEnum.OCEANIA, "CK"],
  [ReginEnum.LATIN_AMERICA, "CR"],
  [ReginEnum.LATIN_AMERICA, "CU"],
  [ReginEnum.LATIN_AMERICA, "CW"],
  [ReginEnum.LATIN_AMERICA, "DM"],
  [ReginEnum.LATIN_AMERICA, "DO"],
  [ReginEnum.LATIN_AMERICA, "EC"],
  [ReginEnum.MIDDLE_EAST, "EG"],
  [ReginEnum.LATIN_AMERICA, "SV"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "EE"],
  [ReginEnum.Other, "FO"],
  [ReginEnum.OCEANIA, "FJ"],
  [ReginEnum.OCEANIA, "PF"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "GE"],
  [ReginEnum.NORTH_AMERICA, "GL"],
  [ReginEnum.LATIN_AMERICA, "GD"],
  [ReginEnum.LATIN_AMERICA, "GP"],
  [ReginEnum.OCEANIA, "GU"],
  [ReginEnum.LATIN_AMERICA, "GT"],
  [ReginEnum.Other, "GG"],
  [ReginEnum.LATIN_AMERICA, "GY"],
  [ReginEnum.LATIN_AMERICA, "HT"],
  [ReginEnum.LATIN_AMERICA, "HN"],
  [ReginEnum.MIDDLE_EAST, "IR"],
  [ReginEnum.MIDDLE_EAST, "IQ"],
  [ReginEnum.Other, "IM"],
  [ReginEnum.LATIN_AMERICA, "JM"],
  [ReginEnum.MIDDLE_EAST, "JO"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "KZ"],
  [ReginEnum.OCEANIA, "KI"],
  [ReginEnum.MIDDLE_EAST, "KW"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "KG"],
  [ReginEnum.SOUTH_EAST_ASIA, "LA"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "LV"],
  [ReginEnum.MIDDLE_EAST, "LB"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "LT"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "MK"],
  [ReginEnum.OCEANIA, "MH"],
  [ReginEnum.LATIN_AMERICA, "MQ"],
  [ReginEnum.OCEANIA, "FM"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "MD"],
  [ReginEnum.EAST_ASIA, "MN"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "ME"],
  [ReginEnum.NORTH_AMERICA, "MS"],
  [ReginEnum.SOUTH_EAST_ASIA, "MM"],
  [ReginEnum.OCEANIA, "NR"],
  [ReginEnum.OCEANIA, "NC"],
  [ReginEnum.LATIN_AMERICA, "NI"],
  [ReginEnum.OCEANIA, "NU"],
  [ReginEnum.OCEANIA, "MP"],
  [ReginEnum.MIDDLE_EAST, "OM"],
  [ReginEnum.OCEANIA, "PW"],
  [ReginEnum.MIDDLE_EAST, "PS"],
  [ReginEnum.LATIN_AMERICA, "PA"],
  [ReginEnum.OCEANIA, "PG"],
  [ReginEnum.LATIN_AMERICA, "PY"],
  [ReginEnum.LATIN_AMERICA, "PE"],
  [ReginEnum.Other, "PN"],
  [ReginEnum.Other, "PR"],
  [ReginEnum.MIDDLE_EAST, "QA"],
  [ReginEnum.Other, "RE"],
  [ReginEnum.Other, "MF"],
  [ReginEnum.OCEANIA, "WS"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "RS"],
  [ReginEnum.NORTH_AMERICA, "SX"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "SK"],
  [ReginEnum.OCEANIA, "SB"],
  [ReginEnum.Other, "SH"],
  [ReginEnum.LATIN_AMERICA, "KN"],
  [ReginEnum.LATIN_AMERICA, "LC"],
  [ReginEnum.Other, "PM"],
  [ReginEnum.LATIN_AMERICA, "VC"],
  [ReginEnum.MIDDLE_EAST, "SY"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "TJ"],
  [ReginEnum.SOUTH_EAST_ASIA, "TL"],
  [ReginEnum.Other, "TK"],
  [ReginEnum.OCEANIA, "TO"],
  [ReginEnum.LATIN_AMERICA, "TT"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "TM"],
  [ReginEnum.Other, "TC"],
  [ReginEnum.OCEANIA, "TV"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "UA"],
  [ReginEnum.LATIN_AMERICA, "UY"],
  [ReginEnum.EASTERN_EUROPE_AND_RUSSIA, "UZ"],
  [ReginEnum.OCEANIA, "VU"],
  [ReginEnum.LATIN_AMERICA, "VE"],
  [ReginEnum.OCEANIA, "WF"],
  [ReginEnum.MIDDLE_EAST, "YE"],
];

export const locationOptions = [
  {
    label: ReginEnum.NORTH_AMERICA,
    value: ReginEnum.NORTH_AMERICA,
    children: [
      {
        label: "Canada",
        value: "CA",
      },
      {
        label: "United States",
        value: "US",
      },
      {
        label: "Greenland",
        value: "GL",
      },
      {
        label: "Anguilla",
        value: "AI",
      },
      {
        label: "Montserrat",
        value: "MS",
      },
      {
        label: "Sint Maarten",
        value: "SX",
      },
      {
        label: "Cayman Islands",
        value: "KY",
      },
      {
        label: "Bermuda",
        value: "BM",
      },
    ],
  },
  {
    label: ReginEnum.LATIN_AMERICA,
    value: ReginEnum.LATIN_AMERICA,
    children: [
      {
        label: "Mexico",
        value: "MX",
      },
      {
        label: "Belize",
        value: "BZ",
      },
      {
        label: "Costa Rica",
        value: "CR",
      },
      {
        label: "El Salvador",
        value: "SV",
      },
      {
        label: "Guatemala",
        value: "GT",
      },
      {
        label: "Honduras",
        value: "HN",
      },
      {
        label: "Nicaragua",
        value: "NI",
      },
      {
        label: "Panama",
        value: "PA",
      },
      {
        label: "Argentina",
        value: "AR",
      },
      {
        label: "Bolivia",
        value: "BO",
      },
      {
        label: "Brazil",
        value: "BR",
      },
      {
        label: "Chile",
        value: "CL",
      },
      {
        label: "Colombia",
        value: "CO",
      },
      {
        label: "Ecuador",
        value: "EC",
      },
      {
        label: "Guyana",
        value: "GY",
      },
      {
        label: "Paraguay",
        value: "PY",
      },
      {
        label: "Peru",
        value: "PE",
      },
      {
        label: "Suriname",
        value: "SR",
      },
      {
        label: "Uruguay",
        value: "UY",
      },
      {
        label: "Venezuela",
        value: "VE",
      },
      {
        label: "Antigua & Barbuda",
        value: "AG",
      },
      {
        label: "Bahamas",
        value: "BS",
      },
      {
        label: "Barbados",
        value: "BB",
      },
      {
        label: "Cuba",
        value: "CU",
      },
      {
        label: "Dominica",
        value: "DM",
      },
      {
        label: "Dominican Republic",
        value: "DO",
      },
      {
        label: "Grenada",
        value: "GD",
      },
      {
        label: "Haiti",
        value: "HT",
      },
      {
        label: "Jamaica",
        value: "JM",
      },
      {
        label: "St. Kitts & Nevis",
        value: "KN",
      },
      {
        label: "St. Lucia",
        value: "LC",
      },
      {
        label: "St. Vincent & Grenadines",
        value: "VC",
      },
      {
        label: "Trinidad & Tobago",
        value: "TT",
      },
      {
        label: "Aruba",
        value: "AW",
      },
      {
        label: "CuraÇAo",
        value: "CW",
      },
      {
        label: "Caribbean Netherlands",
        value: "BQ",
      },
      {
        label: "Guadeloupe",
        value: "GP",
      },
      {
        label: "Martinique",
        value: "MQ",
      },
    ],
  },
  {
    label: ReginEnum.WESTERN_EUROPE,
    value: ReginEnum.WESTERN_EUROPE,
    children: [
      {
        label: "Ireland",
        value: "IE",
      },
      {
        label: "United Kingdom",
        value: "GB",
      },
      {
        label: "France",
        value: "FR",
      },
      {
        label: "Germany",
        value: "DE",
      },
      {
        label: "Spain",
        value: "ES",
      },
      {
        label: "Portugal",
        value: "PT",
      },
      {
        label: "Belgium",
        value: "BE",
      },
      {
        label: "Netherlands",
        value: "NL",
      },
      {
        label: "Luxembourg",
        value: "LU",
      },
      {
        label: "Switzerland",
        value: "CH",
      },
      {
        label: "Austria",
        value: "AT",
      },
      {
        label: "Italy",
        value: "IT",
      },
      {
        label: "Monaco",
        value: "MC",
      },
      {
        label: "Liechtenstein",
        value: "LI",
      },
      {
        label: "San Marino",
        value: "SM",
      },
      {
        label: "Vatican City",
        value: "VA",
      },
      {
        label: "Norway",
        value: "NO",
      },
      {
        label: "Iceland",
        value: "IS",
      },
      {
        label: "Denmark",
        value: "DK",
      },
      {
        label: "Finland",
        value: "FI",
      },
      {
        label: "Greece",
        value: "GR",
      },
      {
        label: "Croatia",
        value: "HR",
      },
      {
        label: "Slovenia",
        value: "SI",
      },
      {
        label: "Sweden",
        value: "SE",
      },
      {
        label: "Madeira",
        value: "#N/A",
      },
      {
        label: "Malta",
        value: "MT",
      },
      {
        label: "Andorra",
        value: "AD",
      },
      {
        label: "Gibraltar",
        value: "GI",
      },
      {
        label: "Jersey",
        value: "JE",
      },
      {
        label: "Azores",
        value: "PT-30",
      },
      {
        label: "Canary Islands",
        value: "ES-CN",
      },
    ],
  },
  {
    label: ReginEnum.EASTERN_EUROPE,
    value: ReginEnum.EASTERN_EUROPE_AND_RUSSIA,
    children: [
      {
        label: "Belarus",
        value: "BY",
      },
      {
        label: "Ukraine",
        value: "UA",
      },
      {
        label: "Poland",
        value: "PL",
      },
      {
        label: "Czechia",
        value: "CZ",
      },
      {
        label: "Slovakia",
        value: "SK",
      },
      {
        label: "Hungary",
        value: "HU",
      },
      {
        label: "Romania",
        value: "RO",
      },
      {
        label: "Bulgaria",
        value: "BG",
      },
      {
        label: "Lithuania",
        value: "LT",
      },
      {
        label: "Latvia",
        value: "LV",
      },
      {
        label: "Estonia",
        value: "EE",
      },
      {
        label: "Moldova",
        value: "MD",
      },
      {
        label: "Serbia",
        value: "RS",
      },
      {
        label: "Bosnia and Herzegovina",
        value: "BA",
      },
      {
        label: "Montenegro",
        value: "ME",
      },
      {
        label: "Albania",
        value: "AL",
      },
      {
        label: "Macedonia",
        value: "MK",
      },
      {
        label: "Armenia",
        value: "AM",
      },
      {
        label: "Azerbaijan",
        value: "AZ",
      },
      {
        label: "Tajikistan",
        value: "TJ",
      },
      {
        label: "Kazakhstan",
        value: "KZ",
      },
      {
        label: "Kyrgyzstan",
        value: "KG",
      },
      {
        label: "Tajikistan",
        value: "UZ",
      },
      {
        label: "Turkmenistan",
        value: "TM",
      },
      {
        label: "Georgia",
        value: "GE",
      },
    ],
  },
  {
    label: ReginEnum.MIDDLE_EAST,
    value: ReginEnum.MIDDLE_EAST,
    children: [
      {
        label: "Saudi Arabia",
        value: "SA",
      },
      {
        label: "United Arab Emirates",
        value: "AE",
      },
      {
        label: "Israel",
        value: "IL",
      },
      {
        label: "Jordan",
        value: "JO",
      },
      {
        label: "Lebanon",
        value: "LB",
      },
      {
        label: "Syria",
        value: "SY",
      },
      {
        label: "Iraq",
        value: "IQ",
      },
      {
        label: "Kuwait",
        value: "KW",
      },
      {
        label: "Oman",
        value: "OM",
      },
      {
        label: "Qatar",
        value: "QA",
      },
      {
        label: "Bahrain",
        value: "BH",
      },
      {
        label: "Yemen",
        value: "YE",
      },
      {
        label: "Iran",
        value: "IR",
      },
      {
        label: "Türkiye",
        value: "TR",
      },
      {
        label: "Palestine",
        value: "PS",
      },
      {
        label: "Egypt",
        value: "EG",
      },
      {
        label: "Cyprus",
        value: "CY",
      },
    ],
  },
  {
    label: ReginEnum.SOUTH_ASIA,
    value: ReginEnum.SOUTH_ASIA,
    children: [
      {
        label: "India",
        value: "IN",
      },
      {
        label: "Pakistan",
        value: "PK",
      },
      {
        label: "Bangladesh",
        value: "BD",
      },
      {
        label: "Nepal",
        value: "NP",
      },
      {
        label: "Sri Lanka",
        value: "LK",
      },
      {
        label: "Bhutan",
        value: "BT",
      },
      {
        label: "Maldives",
        value: "MV",
      },
      {
        label: "Afghanistan",
        value: "AF",
      },
    ],
  },
  {
    label: ReginEnum.SOUTH_EAST_ASIA,
    value: ReginEnum.SOUTH_EAST_ASIA,
    children: [
      {
        label: "Myanmar",
        value: "MM",
      },
      {
        label: "Thailand",
        value: "TH",
      },
      {
        label: "Vietnam",
        value: "VN",
      },
      {
        label: "Malaysia",
        value: "MY",
      },
      {
        label: "Singapore",
        value: "SG",
      },
      {
        label: "Indonesia",
        value: "ID",
      },
      {
        label: "Philippines",
        value: "PH",
      },
      {
        label: "Cambodia",
        value: "KH",
      },
      {
        label: "Laos",
        value: "LA",
      },
      {
        label: "Timor-Leste",
        value: "TL",
      },
      {
        label: "Brunei",
        value: "BN",
      },
    ],
  },
  {
    label: ReginEnum.EAST_ASIA,
    value: ReginEnum.EAST_ASIA,
    children: [
      // {
      //   label: 'China',
      //   value: 'CN'
      // },
      {
        label: "Japan",
        value: "JP",
      },
      {
        label: "South Korea",
        value: "KR",
      },
      {
        label: "North Korea",
        value: "KP",
      },
      {
        label: "Mongolia",
        value: "MN",
      },
      {
        label: "Taiwan Province, China",
        value: "TW",
      },
      {
        label: "Hong Kong SAR China",
        value: "HK",
      },
      {
        label: "Macau SAR China",
        value: "MO",
      },
    ],
  },
  {
    label: ReginEnum.OCEANIA,
    value: ReginEnum.OCEANIA,
    children: [
      {
        label: "Australia",
        value: "AU",
      },
      {
        label: "New Zealand",
        value: "NZ",
      },
      {
        label: "Papua New Guinea",
        value: "PG",
      },
      {
        label: "Fiji",
        value: "FJ",
      },
      {
        label: "Solomon Islands",
        value: "SB",
      },
      {
        label: "Vanuatu",
        value: "VU",
      },
      {
        label: "Samoa",
        value: "WS",
      },
      {
        label: "Kiribati",
        value: "KI",
      },
      {
        label: "Tonga",
        value: "TO",
      },
      {
        label: "Micronesia",
        value: "FM",
      },
      {
        label: "Marshall Islands",
        value: "MH",
      },
      {
        label: "Palau",
        value: "PW",
      },
      {
        label: "Nauru",
        value: "NR",
      },
      {
        label: "Tuvalu",
        value: "TV",
      },
      {
        label: "New Caledonia",
        value: "NC",
      },
      {
        label: "French Polynesia",
        value: "PF",
      },
      {
        label: "Wallis & Futuna",
        value: "WF",
      },
      {
        label: "Cook Islands",
        value: "CK",
      },
      {
        label: "Niue",
        value: "NU",
      },
      {
        label: "American Samoa",
        value: "AS",
      },
      {
        label: "Northern Mariana Islands",
        value: "MP",
      },
      {
        label: "Guam",
        value: "GU",
      },
    ],
  },
  {
    label: ReginEnum.AFRICA,
    value: ReginEnum.AFRICA,
    children: [
      {
        label: "Algeria",
        value: "DZ",
      },
      {
        label: "Angola",
        value: "AO",
      },
      {
        label: "Benin",
        value: "BJ",
      },
      {
        label: "Botswana",
        value: "BW",
      },
      {
        label: "Burkina Faso",
        value: "BF",
      },
      {
        label: "Burundi",
        value: "BI",
      },
      {
        label: "Cameroon",
        value: "CM",
      },
      {
        label: "Central African Republic",
        value: "CF",
      },
      {
        label: "Chad",
        value: "TD",
      },
      {
        label: "Comoros",
        value: "KM",
      },
      {
        label: "Democratic Republic of the Congo",
        value: "CD",
      },
      {
        label: "Republic of the Congo",
        value: "CG",
      },
      {
        label: "Côte d'Ivoire",
        value: "CI",
      },
      {
        label: "Djibouti",
        value: "DJ",
      },
      {
        label: "Equatorial Guinea",
        value: "GQ",
      },
      {
        label: "Eritrea",
        value: "ER",
      },
      {
        label: "Swaziland",
        value: "SZ",
      },
      {
        label: "Ethiopia",
        value: "ET",
      },
      {
        label: "Gabon",
        value: "GA",
      },
      {
        label: "Gambia",
        value: "GM",
      },
      {
        label: "Ghana",
        value: "GH",
      },
      {
        label: "Guinea",
        value: "GN",
      },
      {
        label: "Guinea-Bissau",
        value: "GW",
      },
      {
        label: "Kenya",
        value: "KE",
      },
      {
        label: "Lesotho",
        value: "LS",
      },
      {
        label: "Liberia",
        value: "LR",
      },
      {
        label: "Madagascar",
        value: "MG",
      },
      {
        label: "Malawi",
        value: "MW",
      },
      {
        label: "Mali",
        value: "ML",
      },
      {
        label: "Mauritania",
        value: "MR",
      },
      {
        label: "Mauritius",
        value: "MU",
      },
      {
        label: "Mayotte",
        value: "YT",
      },
      {
        label: "Morocco",
        value: "MA",
      },
      {
        label: "Mozambique",
        value: "MZ",
      },
      {
        label: "Namibia",
        value: "NA",
      },
      {
        label: "Niger",
        value: "NE",
      },
      {
        label: "Nigeria",
        value: "NG",
      },
      {
        label: "Rwanda",
        value: "RW",
      },
      {
        label: "São Tomé and Príncipe",
        value: "ST",
      },
      {
        label: "Senegal",
        value: "SN",
      },
      {
        label: "Seychelles",
        value: "SC",
      },
      {
        label: "Sierra Leone",
        value: "SL",
      },
      {
        label: "Somalia",
        value: "SO",
      },
      {
        label: "South Africa",
        value: "ZA",
      },
      {
        label: "South Sudan",
        value: "SS",
      },
      {
        label: "Sudan",
        value: "SD",
      },
      {
        label: "Tanzania",
        value: "TZ",
      },
      {
        label: "Togo",
        value: "TG",
      },
      {
        label: "Uganda",
        value: "UG",
      },
      {
        label: "Western Sahara",
        value: "EH",
      },
      {
        label: "Zambia",
        value: "ZM",
      },
      {
        label: "Zimbabwe",
        value: "ZW",
      },
      {
        label: "Libya",
        value: "LY",
      },
      {
        label: "Tunisia",
        value: "TN",
      },
      {
        label: "Cape Verde",
        value: "CV",
      },
    ],
  },
  {
    label: ReginEnum.Other,
    value: ReginEnum.Other,
    children: [
      {
        label: "Antarctica",
        value: "AQ",
      },
      {
        label: "Åland Islands",
        value: "AX",
      },
      {
        label: "Bouvet Island",
        value: "BV",
      },
      {
        label: "British Indian Ocean Territory",
        value: "IO",
      },
      {
        label: "Falkland Islands",
        value: "FK",
      },
      {
        label: "Faroe Islands",
        value: "FO",
      },
      {
        label: "Guernsey",
        value: "GG",
      },
      {
        label: "Heard Island and McDonald Islands",
        value: "HM",
      },
      {
        label: "Isle of Man",
        value: "IM",
      },
      {
        label: "Jersey",
        value: "JE",
      },
      {
        label: "Saint Martin",
        value: "MF",
      },
      {
        label: "St. Pierre & Miquelon",
        value: "PM",
      },
      {
        label: "Pitcairn Islands",
        value: "PN",
      },
      {
        label: "Puerto Rico",
        value: "PR",
      },
      {
        label: "Réunion",
        value: "RE",
      },
      {
        label: "St. Helena",
        value: "SH",
      },
      {
        label: "Svalbard and Jan Mayen",
        value: "SJ",
      },
      {
        label: "Tokelau",
        value: "TK",
      },
      {
        label: "Turks & Caicos Islands",
        value: "TC",
      },
      {
        label: "U.S. Minor Outlying Islands",
        value: "UM",
      },
      {
        label: "British Virgin Islands",
        value: "VG",
      },
      {
        label: "U.S. Virgin Islands",
        value: "VI",
      },
    ],
  },
];

// 枚举的动态生成函数
function createEnum(
  data: {
    children: { label: string; value: string }[];
  }[],
): Record<string, string> {
  const enumObject: Record<string, string> = {};

  data?.forEach((group) => {
    group?.children?.forEach((item) => {
      enumObject[item.value] = item.label;
    });
  });
  return enumObject;
}

export const NationsLab: Record<string, string> = {
  ...createEnum(locationOptions),
  CN: "China",
};

export const languageToCountryMap: any = {
  id: "ID",
  ms: "MY,BN",
  vi: "VN",
  fil: "PH",
  th: "TH",
  lo: "LA",
  km: "KH",
  my: "MM",
  ko: "KR",
  ja: "JP",
  zh: "TW,HK,MO",
  mn: "MN",
  hi: "IN",
  ur: "PK",
  bn: "BD",
  ne: "NP",
  si: "LK",
  dv: "MV",
  dz: "BT",
  ru: "RU,KZ,KG,BY",
  uk: "UA",
  be: "BY",
  ro: "MD,RO",
  tg: "TJ",
  kk: "KZ",
  ky: "KG",
  uz: "UZ",
  tk: "TM",
  fa: "IR",
  tr: "TR",
  he: "IL",
  el: "CY,GR",
  ka: "GE",
  hy: "AM",
  az: "AZ",
  am: "ET",
  ti: "ER",
  so: "SO",
  sw: "TZ",
  rw: "RW",
  rn: "BI",
  crs: "SC",
  zu: "ZA",
  pt: "PT",
  ny: "ZW",
  mg: "MG",
  ss: "SZ",
  swb: "KM",
  st: "LS",
  ar: "MR",
  kl: "CA",
  ht: "CR",
  nl: "NL,BE",
  de: "DE,AT,CH,LI",
  it: "IT",
  sv: "SE",
  no: "NO",
  da: "DK",
  fi: "FI",
  is: "IS",
  ga: "IE",
  pl: "PL",
  cs: "CZ",
  sk: "SK",
  hu: "HU",
  lb: "LU",
  bg: "BG",
  sr: "RS",
  sq: "AL",
  sl: "SI",
  hr: "HR",
  cnr: "ME",
  mt: "MT",
  la: "VA",
  ca: "AD",
  et: "EE",
  lv: "LV",
  lt: "LT",
  fo: "FO",
  bs: "BA",
  pau: "PW",
  mh: "MH",
  gil: "KI",
  na: "NR",
  bi: "VU",
  fj: "FJ",
  tvl: "TV",
  sm: "WS,AS",
  to: "TO",
  rar: "CK",
  niu: "NU",
  tkl: "TK",
  mk: "MK",
};

const countryLanguageMap: any = {
  ID: "id",
  MY: "ms",
  VN: "vi",
  PH: "fil,en",
  TH: "th",
  SG: "en,ms,zh,ta",
  LA: "lo",
  KH: "km",
  MM: "my",
  BN: "ms",
  TL: "pt",
  KR: "ko",
  JP: "ja",
  TW: "zh",
  HK: "zh,en",
  MO: "zh,pt",
  MN: "mn",
  IN: "hi,en",
  PK: "ur,en",
  BD: "bn",
  NP: "ne",
  LK: "si,ta",
  MV: "dv",
  BT: "dz",
  RU: "ru",
  UA: "uk",
  BY: "be,ru",
  MD: "ro",
  TJ: "tg",
  KZ: "kk,ru",
  KG: "ky,ru",
  UZ: "uz",
  TM: "tk",
  SA: "ar",
  IR: "fa",
  IQ: "ar,ku",
  KW: "ar",
  AE: "ar",
  OM: "ar",
  QA: "ar",
  BH: "ar",
  TR: "tr",
  IL: "he",
  PS: "ar",
  SY: "ar",
  LB: "ar",
  JO: "ar",
  YE: "ar",
  CY: "el,tr",
  GE: "ka",
  AM: "hy",
  AZ: "az",
  EG: "ar",
  LY: "ar",
  TN: "ar",
  DZ: "ar",
  MA: "ar",
  EH: "ar",
  SD: "ar,en",
  SS: "en",
  ET: "am",
  ER: "ti,ar,en",
  SO: "so,ar",
  DJ: "fr,ar",
  KE: "en,sw",
  TZ: "sw,en",
  UG: "en,sw",
  RW: "rw,en,fr",
  BI: "rn,fr,en",
  SC: "crs,en,fr",
  ZA: "zu,xh,en",
  ZM: "en",
  AO: "pt",
  ZW: "ny,en",
  MU: "en,fr",
  MG: "mg,fr",
  SZ: "ss,en",
  KM: "swb,ar,fr",
  NA: "en",
  MW: "en",
  MZ: "pt",
  BW: "en",
  LS: "st,en",
  RE: "fr",
  SH: "en",
  NG: "en",
  NE: "fr",
  MR: "ar",
  SN: "en",
  GM: "fr",
  ML: "en",
  BF: "fr",
  GN: "pt",
  GW: "pt",
  CV: "en",
  SL: "en",
  LR: "fr",
  CI: "en",
  GH: "en",
  TG: "fr",
  BJ: "en",
  TD: "es",
  CM: "es",
  GQ: "es",
  GA: "en",
  ST: "en,fr",
  US: "es,en",
  CA: "en",
  MX: "fr",
  GL: "pt",
  PM: "es",
  BR: "pt",
  CO: "es",
  AR: "es",
  PE: "en",
  CL: "es",
  JM: "es",
  PA: "en",
  CU: "es",
  BS: "es",
  UY: "es",
  PY: "es",
  EC: "es",
  VE: "es",
  GT: "es",
  BO: "es",
  NI: "es",
  CR: "ht",
  HT: "es",
  DO: "en",
  AG: "en",
  KN: "en",
  DM: "en",
  LC: "en",
  VC: "en",
  GD: "en",
  BB: "en",
  TT: "es,en",
  PR: "en",
  VG: "en",
  AI: "en",
  MS: "fr",
  GP: "fr",
  MQ: "nl",
  AW: "nl,en",
  CW: "nl,en",
  SX: "en",
  TC: "en",
  KY: "en",
  BM: "fr",
  MF: "en",
  BZ: "en",
  SV: "es",
  HN: "es",
  FR: "fr",
  GB: "en",
  DE: "de",
  AT: "de",
  ES: "es",
  PT: "pt",
  IT: "it",
  GR: "el",
  SE: "sv",
  NO: "no",
  DK: "da",
  FI: "fi,sv",
  IS: "is",
  CH: "de,fr,it",
  IE: "ga,en",
  NL: "nl",
  PL: "pl",
  CZ: "cs",
  SK: "sk",
  HU: "hu",
  LI: "de",
  BE: "nl,fr,de",
  LU: "lb,fr,de",
  MC: "fr",
  RO: "ro",
  BG: "bg",
  RS: "sr",
  AL: "sq",
  SI: "sl",
  HR: "hr",
  ME: "cnr,sr",
  MT: "mt,en",
  VA: "la,it",
  AD: "ca",
  SM: "it",
  EE: "et",
  LV: "lv",
  LT: "lt",
  FO: "fo,da",
  GI: "en",
  BA: "bs,hr",
  AU: "en",
  NZ: "en",
  PW: "pau,en",
  FM: "en",
  MH: "mh,en",
  KI: "gil,en",
  NR: "na,en",
  MP: "en",
  GU: "en",
  PG: "en",
  SB: "en",
  VU: "bi,en",
  FJ: "fj,en",
  NC: "fr",
  TV: "tvl,en",
  WS: "sm,en",
  TO: "to,en",
  CK: "rar",
  NU: "niu,en",
  TK: "tkl,en",
  PF: "fr",
  WF: "fr",
  PN: "en",
  AS: "sm,en",
  YT: "fr",
  IM: "en",
  GG: "en,fr",
  GY: "en",
  MK: "mk",
  KP: "ko",
};

// 检查国家和语言的diff
export const checkDiffCToL = (languages: string[], locations: string[]) => {
  // 缺失
  const miss = {
    country: new Set(),
    languages: new Set(),
    // 语言简称
    languageAbbreviation: new Set(),
    // 国家简称
    countryAbbreviation: new Set(),
  };
  const selected = {
    country: new Set(),
    languages: new Set(),
  };
  const location = locations?.map((item) => item?.[1]);
  location?.forEach((country) => {
    const language = countryLanguageMap[country];
    if (language?.includes(",")) {
      const languageArr = language?.split(",");
      languageArr?.forEach((l: LanguageEnum) => {
        if (!languages?.includes(l) && languageLabel?.[l]) {
          miss?.languages.add(languageLabel?.[l]);
          miss?.languageAbbreviation.add(l);
          selected?.country.add(NationsLab?.[country]);
        }
      });
    } else {
      if (
        !languages?.includes(language) &&
        languageLabel?.[language as LanguageEnum]
      ) {
        miss?.languages.add(languageLabel?.[language as LanguageEnum]);
        miss?.languageAbbreviation.add(language);
        selected?.country.add(NationsLab?.[country]);
      }
    }
  });
  languages?.forEach((language) => {
    const country = languageToCountryMap?.[language];
    if (country?.includes(",")) {
      const countryArr = country?.split(",");
      countryArr?.forEach((c: string) => {
        if (!location?.includes(c) && NationsLab?.[c]) {
          miss?.country.add(NationsLab?.[c]);
          miss?.countryAbbreviation.add(c);
          selected?.languages.add(languageLabel?.[language as LanguageEnum]);
        }
      });
    } else {
      if (!location?.includes(country) && NationsLab?.[country]) {
        miss?.country.add(NationsLab?.[country]);
        miss?.countryAbbreviation.add(country);
        selected?.languages.add(languageLabel?.[language as LanguageEnum]);
      }
    }
  });
  return {
    miss: {
      country: Array.from(miss?.country),
      languages: Array.from(miss?.languages),
      languageAbbreviation: Array.from(miss?.languageAbbreviation),
      countryAbbreviation: Array.from(miss?.countryAbbreviation),
    },
    selected: {
      country: Array.from(selected?.country),
      languages: Array.from(selected?.languages),
    },
  };
};

export enum AdsCampaignMatchingAccuracy {
  FOCUS_MODE = "Focus Mode",
  SCALE_MODE = "Scale Mode",
  MAX_SCALE_MODE = "Max Scale Mode",
}

// 根据内容形式获取平台
export const getContentFormatToPlatformMap = (t: any) => ({
  [PlatformContentEnum.YOUTUBE_DEDICATED]: t("common.YouTube"),
  [PlatformContentEnum.YOUTUBE_INTEGRATED]: t("common.YouTube"),
  [PlatformContentEnum.TIKTOK_VIDEO]: t("common.TikTok"),
  [PlatformContentEnum.INSTAGRAM_REEL]: t("common.Instagram"),
  [PlatformContentEnum.INSTAGRAM_CAROUSEL_POST]: t("common.Instagram"),
  [PlatformContentEnum.TWITTER_POST]: t("common.Twitter"),
  [PlatformContentEnum.LINKEDIN_POST]: t("common.LinkedIn"),
  [PlatformContentEnum.LINKEDIN_IMAGE_POST]: t("common.LinkedIn"),
  [PlatformContentEnum.LINKEDIN_VIDEO_POST]: t("common.LinkedIn"),
});

export const getPlatformByContentFormat = (placements: string[], t: any) => {
  const res = new Set();
  placements?.forEach((item) => {
    res.add(
      getContentFormatToPlatformMap(t)?.[
        item as keyof typeof getContentFormatToPlatformMap
      ],
    );
  });
  return Array.from(res);
};
